import styled from 'styled-components';

import { getSpacing } from 'stylesheetB2b';

export const ControlButtons = styled.div`
  margin-right: ${getSpacing(6)};
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;
ControlButtons.displayName = 'ControlButtons';
